import { useCallback, useContext, useState } from "react";

import { Tabs } from "@hdi-seguros/web-components.tabs";

import { SavedAndSentPreLiquidationsContext } from "../../contexts/SavedAndSentPreLiquidations";

export const PreLiquidationsTabs = () => {

    const { TABS_ITEMS = [] } = useContext(SavedAndSentPreLiquidationsContext);

    const [activeKey, setActiveKey] = useState<string>("1");

    const hanldePressTab = useCallback(
        (activeKey: string) => setActiveKey(activeKey), [setActiveKey]
    );

    return (
        <Tabs 
            handlePressTab={hanldePressTab}
            activeKey={activeKey}
            items={TABS_ITEMS}
        />
    )
}
